import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import { HeadingL, ProfileMenuV2, ProfileVariant, useIsDesktop, useTypedTranslation } from '@repo/ui';

import { isProfileV2Enabled, usePortalProfile, useProfile } from "../../queryHooks";
import { InternalAttentionLink } from "../Link/InternalButtonLink";
import LogoutButton from "../LogoutButton";
import * as Styled from "./Menu.styled";

const CommonProfileLinks = ({ isProfileV2 }: { isProfileV2: boolean }) => {
	const { t } = useTypedTranslation();

	return (
		<Stack spacing={3}>
			<InternalAttentionLink
				to="/profil/moje-udaje/"
				startIcon={<Styled.PersonIcon />}
			>
				{t("profile.menu.myData")}
			</InternalAttentionLink>
			{!isProfileV2 && (
				<InternalAttentionLink
					to="/profil/adresy/"
					startIcon={<Styled.AddressIcon />}
				>
					{t("profile.person.address")}
				</InternalAttentionLink>
			)}
			<InternalAttentionLink
				to="/profil/zmeny/"
				startIcon={<Styled.PencilIcon />}
			>
				{t("profile.menu.changeList")}
			</InternalAttentionLink>
		</Stack>
	);
};

const CommonOtherLinks = () => {
	const { t } = useTypedTranslation();

	return (
		<Stack spacing={3}>
			<InternalAttentionLink
				to="/profil/souhlas-s-elektronickou-komunikaci-a-kontraktaci/"
				startIcon={<Styled.ContractsIcon />}
			>
				{t("profile.communicationContractation.header")}
			</InternalAttentionLink>
			<InternalAttentionLink
				to="/profil/marketingovy-souhlas/"
				startIcon={<Styled.ContractsIcon />}
			>
				{t("profile.marketing.header")}
			</InternalAttentionLink>
			<InternalAttentionLink
				to="/profil/ochrana-osobich-udaju/"
				startIcon={<Styled.FilesIcon />}
			>
				{t("profile.other.item.privacyPolicy")}
			</InternalAttentionLink>
			<InternalAttentionLink
				to="/profil/cookies/"
				startIcon={<Styled.CookieIcon />}
			>
				{t("profile.cookies.header")}
			</InternalAttentionLink>
		</Stack>
	);
};

const MenuV1 = () => {
	const isD = useIsDesktop();
	const { t } = useTypedTranslation();
	const result = useProfile();
	const { firstName, lastName } = result.data?.client || {
		firstName: null,
		lastName: null,
	};

	return (
		<Stack
			spacing={7}
			sx={{ px: isD ? undefined : 4 }}
		>
			<Stack>
				<HeadingL withoutScale>
					{!result.isSuccess ? <Skeleton /> : [firstName, lastName].filter(Boolean).join(" ")}
				</HeadingL>
				<CommonProfileLinks isProfileV2={false} />
			</Stack>
			<Stack>
				<HeadingL withoutScale>{t("profile.menu.other")}</HeadingL>
				<CommonOtherLinks />
			</Stack>
			{!isD && <LogoutButton />}
		</Stack>
	);
};

const MenuV2 = () => {
	const result = usePortalProfile();
	const { firstName, lastName } = result.data?.client || {
		firstName: null,
		lastName: null,
	};

	return (
		<ProfileMenuV2
			fullName={[firstName, lastName].filter(Boolean).join(" ")}
			isLoading={result.isLoading}
			profileLinks={<CommonProfileLinks isProfileV2 />}
			otherLinks={<CommonOtherLinks />}
			logoutAction={<LogoutButton />}
		/>
	);
};

export const Menu = () => {
	return <ProfileVariant isV2={isProfileV2Enabled()} v1={<MenuV1 />} v2={<MenuV2 />} />;
};
